module.exports = "https://i-jinbaozheng-network-website.oss-cn-shanghai.aliyuncs.com//img/jtyh.576ac5b4.png";